import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Row, Col, } from 'reactstrap'
import StudentsInClassList from './AddStudentsToClasses/StudentsInClassList'
import StudentsNotInClassList from './AddStudentsToClasses/StudentsNotInClassList'

/*
  <AddStudentsToClassesCard
    students={this.props.students}
    selectedClass={this.props.selection.class}
    classes={this.props.classes}
  />
*/

class AddStudentsToClassesCard extends Component {

  render() {
    let thisClass = null
    if (this.props.classes) {
      thisClass = this.props.classes[this.props.selectedClass]
    }

    let addStudentsToClassesCardBody = null
    if (this.props.selectedClass) {
      addStudentsToClassesCardBody = (
        <CardBody>
          <Row>
            <Col xs='12' sm='6'>
              <StudentsInClassList 
                thisClass={thisClass}
                students={this.props.students}
              />
            </Col>
            <Col xs='12' sm='6'>
              <StudentsNotInClassList 
                thisClass={thisClass}
                students={this.props.students}
                schools={this.props.schools}
              />
            </Col>
          </Row>
        </CardBody>
      )
    }
    
    return (
      <Card>
        <CardHeader>
          Add Students to Classes
        </CardHeader>
        {addStudentsToClassesCardBody}
      </Card>
    )
  }
}

export default AddStudentsToClassesCard


// WEBPACK FOOTER //
// ./src/components/Users/AddStudentsToClassesCard.js